import { ReservationService } from "./../services/reservation-service/reservation.service";
import { environment } from "./../../environments/environment";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Component, OnInit } from "@angular/core";
import { PaymentService } from "../services/payment/payment.service";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ProjectsService } from "../services/projects/projects.service";
import "rxjs/add/observable/of";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import swal from "sweetalert2";

@Component({
  selector: "app-contract-generate",
  templateUrl: "./contract-generate.component.html",
  styleUrls: ["./contract-generate.component.css"],
})
export class ContractGenerateComponent implements OnInit {
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));

  reservation_id: any;
  contract_template_id = "";
  project_id: any;

  is_loading: boolean = false;

  contractForm = [];

  sharing_leads: any;
  types: any = ["National ID", "Passport"];
  contractsTemplates = [];

  contracts: any;
  unit_id: number;
  sharing_type: string;
  constructor(
    private http: HttpClient,
    private paymentService: PaymentService,
    private projectsService: ProjectsService,
    private fb: FormBuilder,
    private router: Router,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    private route: ActivatedRoute,
    private reservationService: ReservationService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.reservation_id = +params["id"] || 0;
      this.project_id = +params["project_id"];
      this.fetchReservation();
    });
  }

  ngOnInit() {}

  getContractsTemplates(unit_id) {
    this.reservationService
      .getContractsTemplates(unit_id)
      .subscribe((data: any) => {
        this.contractsTemplates = data;
      });
  }

  fetchReservation() {
    this.reservationService.getSingleReservation(this.reservation_id).subscribe(
      (data: any) => {
        this.unit_id = data.data[0].unit.id;
        this.sharing_leads = data.data[0].sharing_leads;
        this.createForm();
        this.getContractsTemplates(this.unit_id);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  receivePhone(event, obj, phone, code, err) {
    this[obj][err] = event.phoneError;
    this[obj][phone] = event.phone;
    this[obj][code] = event.code;
  }

  createForm() {
    console.log(this.sharing_leads);
    this.sharing_leads.map((lead) => {
      this.contractForm.push({
        client_name_en: lead.lead_name,
        client_name_ar: lead.lead_name,
        client_address_en: lead.lead_address,
        client_address_ar: lead.lead_address,
        client_mailing_address_en: "",
        client_mailing_address_ar: "",
        client_nationality_en: lead.lead_nationality,
        client_nationality_ar: lead.lead_nationality,
        client_nationality_id: lead.lead_national_id,
        client_email: lead.lead_email,
        client_phone: lead.lead_phone,
        lead_id: lead.lead_id,
        include_customer: true,
      });
    });
    console.log(this.contractForm);
    setTimeout(() => {
      this.contractForm.map((customer, i) => {
        customer.client_phone_without_code = this.sharing_leads[i].lead_phone_without_code;
        customer.client_code = this.sharing_leads[i].lead_code;
      })
    }, 1000);
  }

  generateContract() {
    let data = {
      reservation_id: this.reservation_id,
      clients: this.contractForm.filter(
        (customer) => customer.include_customer
      ),
      contract_template_id: this.contract_template_id,
      sharing_type: this.sharing_type,
    };
    this.is_loading = true;
    this.reservationService.generateContract(data).subscribe(
      (res: any) => {
        swal("Success!", "", "success");
        // this.contractForm = [];
        // this.createForm();
        this.contracts = res;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => (this.is_loading = false)
    );
  }

  openContract(url) {
    window.open(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/contract-generate/contract-generate.component.ts